import * as React from "react";
const SvgFiRrTransgender = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transgender_svg__a)">
      <path
        fill="#062147"
        d="M22 0h-3a1 1 0 0 0 0 2h1.586l-5.115 5.115a5.96 5.96 0 0 0-6.942 0L7.222 5.808l.793-.793a.999.999 0 1 0-1.414-1.414l-.793.793L3.414 2H5a1 1 0 0 0 0-2H2C.897 0 0 .897 0 2v3a1 1 0 0 0 2 0V3.414l2.394 2.394-.793.793a.999.999 0 1 0 1.414 1.414l.793-.793 1.307 1.307A5.96 5.96 0 0 0 6 12c0 2.967 2.167 5.431 5 5.91V20h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2h-1v-2.09c2.833-.478 5-2.942 5-5.91 0-1.294-.416-2.49-1.115-3.471L22 3.414V5a1 1 0 0 0 2 0V2c0-1.103-.897-2-2-2M12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transgender_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransgender;
